import { useEffect } from "react";
import usePagination from "./usePagination";
import { useQuery, useSubscription } from "@apollo/client";
import { IETDStatus, IETDStatusIndexParams } from "models/ETDStatus";
import { GET_ETD_STATUS } from "graphql/queries/etd_status";
import { OnLastETDData } from "graphql/subscriptions/etd_status";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 10;

const useETDStatuses = ({
    etd_id,
    page: externalPage = DEFAULT_PAGE,
    pageSize: externalPageSize = DEFAULT_PAGE_SIZE,
    orderBy = "desc",
}: IETDStatusIndexParams) => {

    const hookETDStatus = usePagination<IETDStatus>({
        page: externalPage,
        pageSize: externalPageSize,
        sortOrder: orderBy as "desc" | "asc"
    });

    const { page, pageSize } = hookETDStatus;
    const { data, loading } = useQuery(GET_ETD_STATUS(etd_id, page, pageSize, orderBy), {
        // pollInterval: 1000*60, //Actualiza cada minuto
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'network-only',
    });

    const { data: lastDataETDStatus } = useSubscription(OnLastETDData, { variables: { etd_id } });

    useEffect(() => {
        if (lastDataETDStatus) {
            const { its_etd_statuses } = lastDataETDStatus;
            hookETDStatus.addElement(its_etd_statuses)
        }
    }, [lastDataETDStatus]);

    useEffect(() => {
        if (loading) {
            hookETDStatus.loadingStart();
        } else {
            hookETDStatus.loadingEnd();
        }

        if (data) {
            const { its_etd_statuses: dataETDStatus, its_etd_statuses_aggregate } = data;
            const { count: totalItems } = its_etd_statuses_aggregate.aggregate;
            hookETDStatus.setData(dataETDStatus);
            hookETDStatus.setTotalItems(totalItems);
        }
    }, [data, loading]);

    return hookETDStatus;
};

export default useETDStatuses;
